import React, {useEffect, useState} from 'react';
// import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {HashRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import './App.css';
import routes from "../config/routes";

import LandingPage from '../pages/LandingPage/LandingPage.lazy';
import Login from './Login/Login.lazy';
import DashboardPage from "../pages/DashboardPage/DashboardPage.lazy";
import Dashboard from "./Dashboard/Dashboard.lazy";
import Error404 from './Error404/Error404.lazy';
import Leaderboard from "./Leaderboard/Leaderboard.lazy";
import AuthenticationPage from "../pages/AuthenticationPage/AuthenticationPage.lazy";
import {useAppSelector} from "../store";
import {Alert, AlertColor, Button, Snackbar} from '@mui/material';
import {ErrorBoundary} from "react-error-boundary";
import {useDispatch} from "react-redux";
import {discardFirstNotification} from "../actions/notificationsSlice";
import ScoreHistory from "./ScoreHistory/ScoreHistory.lazy";


const Error = ({error, resetErrorBoundary}: { error: any; resetErrorBoundary(): void }) => {
    console.log('ERROR', error);
    return (<>Error</>)
}

function App() {
    const dispatch = useDispatch()
    const isLogged = useAppSelector(state => state.user.isAuthenticated)
    const systemNotifications = useAppSelector(state => state.notifications.snackbar)
    const [notification, setNotification] = useState(false)
    const [notificationMessage, setNotificationMessage] = useState<{
        message: string;
        body?: string;
        type?: AlertColor
    }>({message: '', body: ''})
    const handleCloseNotification = () => {
        setNotification(false)
    }

    useEffect(() => {
        if (systemNotifications && systemNotifications.length > 0 && !notification) {
            console.log(systemNotifications[0])
            setNotificationMessage(systemNotifications[0] as any)
            setNotification(true)
            dispatch(discardFirstNotification())
        }
    }, [systemNotifications, notification])

    return (<>
            <ErrorBoundary FallbackComponent={Error}>
                <Router future={{v7_startTransition: true}}>
                    <Routes>
                        <Route index element={<LandingPage/>}/>
                        <Route path={routes.authentication} element={<AuthenticationPage/>}>
                            <Route index element={<Login/>}/>
                            <Route path={routes.login} element={<Login/>}/>
                            {/*<Route path={routes.register} element={<RegisterUser/>}/>*/}
                        </Route>
                        <Route path={routes.dashboard}
                               element={isLogged ? <DashboardPage/> : <Navigate to={routes.login}/>}>
                            <Route index element={<Dashboard/>}/>
                            <Route path={routes.leaderboard} element={<Leaderboard/>}/>
                            <Route path={routes.scoreHistory} element={<ScoreHistory/>}/>
                            {/*<Route path={routes.me} element={<Profile/>}/>*/}
                            <Route path="*" element={<Error404/>}/>
                        </Route>
                        <Route path="*" element={<Error404/>}/>
                    </Routes>
                </Router>
            </ErrorBoundary>
            <Snackbar open={notification} message={notificationMessage.message ?? ''} autoHideDuration={6000}
                      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                      onClose={handleCloseNotification}><Alert
                onClose={handleCloseNotification}
                severity={notificationMessage.type as AlertColor ?? 'info'}
                variant="filled"
                sx={{width: '100%'}}
            >{notificationMessage.body ?? notificationMessage.message}
            </Alert></Snackbar>
        </>
    );
}

export default App;
